<template>
  <div>
    <layout-top/>

		<div class="container">
      <layout-lmenu/>

      <router-view/>

		</div>

    <layout-footer/>

     <div v-if="_config.IS_LOCAL" app style="height: 20px; min-height: 20px; padding: 0px;">
       [로컬전용]
      {{ user }}
       <span> last = {{ $store.state.session.lastTokenResponseTime }} </span>
       <span>, lat = {{ $store.state.session.user.iat * 1000 }} </span>
       <span>, diff = {{ $store.state.session.lastTokenResponseTime - $store.state.session.user.iat * 1000 }} </span>
       <span>, diff2 = {{ $store.state.session.tokenTimeDiff }} </span>
       <span class="mr-1" style="line-height: 20px;">로그아웃까지 남은시간 : {{ lefttime_dp }}</span>
       <i-btn xm white @click="tokenRefresh" style="margin-top: -1px; padding-bottom: -2px;" color="primary" >갱신</i-btn>
    </div>


  </div>
</template>

<style scoped>

</style>

<script>
import { mapGetters } from 'vuex'
import _config from '../plugins/config'

export default {
  components: {
    // 'dev-comment-editor' : require('@/components/DevCommentEditor.vue').default,
    'layout-top'    : require('@/layouts/top.vue').default,
    'layout-lmenu'  : require('@/layouts/lmenu.vue').default,
    'layout-footer' : require('@/layouts/footer.vue').default,
  },
  data () {
    return {
      drawer: null,
      menuFix: false,
      menus: [],
      open: [1, 2],
      search: null,
      // showMenu: false,
      tree: [],
      lefttime_dp: "계산중",
      timerInst: null,

      navigation: { // 드레그 리사이즈 이동 설정
        width: 470, // width: 275,
        shown: false,
        borderSize: 20
      },
    }
  },
  // props: {
  //   source: String
  // },
  created () {
    this.setRouteProgressBar() // 라우터 로딩 progress 바 설치
    this.menus = this.menuList
    // this.$store.dispatch('menu/loadDevStatus') // 개발상태 로딩
    const w = this.menuFixRead()
    this.menuFix = !!w
    if (this.menuFix)
      this.navigation.width = w
  },
  mounted () {

    // this.setDragResize() // 드래그 리사이즈 호출
    this.$Progress.finish() // 라우터 로딩끝나면 progress bar 종료

    let cnt = 0;
    this.timerInst = setInterval(()=>{

      if (++cnt >= 10) { // 10초 정도마다 쿠키를 다시 확인한다.
        cnt = 0;
        this.$store.commit("session/SET_TOKEN_FROM_COOKIE", 1)
      }

      let sec = this.getLeftSessionSecond()
      if (sec < 0) {
        this.$store.commit("session/SET_TOKEN_FROM_COOKIE", 2) // 혹시 모르니 쿠키를 한번 더 체크하고
        sec = this.getLeftSessionSecond() // 남은시간 다시 가져와서
        if (sec < 0) { // 그래도 만료라면
          clearInterval(this.timerInst) // 타이머 종료하고 로그아웃
          return this.doLogout('만료시간이 다되어 자동으로 로그아웃 되었습니다.') // 시간 만료면 자동 로그아웃
        }
      }

      let dp = ""
      if (sec >= 60 * 60) {
        const hour = Math.floor(sec / (60 * 60))
        sec = sec % (60 * 60)
        dp = hour + " 시간1 "
      }
      if (sec >= 60) {
        const minute = Math.floor(sec / 60)
        sec = sec % 60
        dp += minute + " 분 "
      }
      this.lefttime_dp = dp + sec + " 초"

    }, 1000)
  },
  beforeDestroy() {
    console.log("[Layout] beforeDestroy()");
    if (this.timerInst) {
      console.log("[Layout] beforeDestroy() - clearInterval");
      clearInterval(this.timerInst)
    }
  },
  computed: {
    ...mapGetters('session', ['user']),
    ...mapGetters('menu', ['menu', 'menuList']),
  },
  methods: {
    doLogout(msg) {
      this.$ui.notify(msg)
      console.log('[JWT] ' + msg)
      this.$store.dispatch("session/LOGGED_OUT")
      this.$router.push(_config.LOGIN_PATH)
    },
    menuFixRead() { return this.$cookie.get('menufix') },
    menuFixSave() {
      if (this.menuFix && this.navigation.width != '0px') {
        this.$cookie.set('menufix', this.navigation.width)
      } else {
        this.$cookie.delete('menufix')
      }
    },
    getLeftSessionSecond() {
      // console.log("user =",this.$store.state.session.user);

      const sec = Math.round(this.$store.state.session.user.exp - new Date().getTime() / 1000)
      return sec + this.$store.state.session.tokenTimeDiff // 로컬 pc시간하고 서버 시간하고 차이 반영
    },
    route(parentMenuIndex) {
      if (arguments.length) {
        console.log("[Layout.vue] route(parentMenuIndex) - parentMenuIndex =",parentMenuIndex, "arguments.length =", arguments.length);

        const parentMenu = this.$refs.menuRef[parentMenuIndex];

        console.log("[Layout.vue] route(parentMenuIndex) - parentMenu =", parentMenu);

        // parentMenu.isActive = false;
        _.set(parentMenu, "isActive", false)
      }
    },

    // ----------------------------------------------------------------------------------------------------------------------------------
    // 라우터 로딩시 progress bar
    // ----------------------------------------------------------------------------------------------------------------------------------
    // 관련소스 : 1. created() : setRouteProgressBar()
    //            2. mounted() : this.$Progress.finish()
    // ----------------------------------------------------------------------------------------------------------------------------------
    setRouteProgressBar() {
      this.$Progress.start()
      this.$router.beforeEach((to, from, next) => {
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        if (to.path !== '/member/logout') { // 로그아웃시에는 어딜가는게 아니니깐 프로그래스바를 시작하지 않는다.
          this.$Progress.start()
        }
        next()
      })
      this.$router.afterEach(() => this.$Progress.finish() )
    },

    tokenRefresh() {
      this.$store.dispatch("session/TOKEN_REFRESH", {refreshType: 'user'})
    },

  },
}



</script>
